export default __webpack_public_path__ + "static/media/pic (3).72ba5fbb.jpg";